var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 116,
    viewBox: "0 0 85 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#CDCDCD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M82.95 2.47l.033.142 1.979 10c.214 1.083-.49 2.136-1.574 2.35-1.034.205-2.04-.428-2.316-1.428l-.034-.146-1.054-5.327L8.92 111.776l5.148-1.216c1.026-.243 2.054.352 2.366 1.342l.04.144c.254 1.075-.411 2.152-1.486 2.406l-10.55 2.494c-1.102.261-2.201-.446-2.421-1.558l-1.979-10c-.214-1.083.49-2.136 1.574-2.35 1.083-.214 2.135.49 2.35 1.574l1.125 5.682L76.456 6.134 70.932 7.44c-1.026.243-2.054-.352-2.366-1.342l-.04-.144c-.243-1.026.353-2.054 1.342-2.367l.144-.04 10.55-2.493c1.054-.25 2.106.386 2.388 1.415z",
    transform: "translate(-925 -2650) translate(598 2517) matrix(-1 0 0 1 412 132)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow3);
export default __webpack_public_path__ + "static/media/arrow-3.32f1aa52.svg";
export { ForwardRef as ReactComponent };